/**
 * Purpose: Consistent heading row for page sections (title, count, subtitle, action slot).
 * Inputs: title, count (optional number), subtitle, action (node, e.g. owner CTA),
 *         as (heading tag, default 'h2').
 * Outputs: flex header row; heading semantics preserved for accessibility.
 */
import React from 'react';

const SectionHeader = ({ title, count = null, subtitle = null, action = null, as = 'h2', className = '' }) => {
  const HeadingTag = as;
  return (
    <div className={`mb-4 flex items-start justify-between gap-3 ${className}`}>
      <div className="min-w-0">
        <HeadingTag className="flex items-center gap-2 text-lg font-bold text-gray-900 dark:text-gray-100 sm:text-xl">
          <span className="truncate">{title}</span>
          {count != null && (
            <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600 dark:bg-gray-800 dark:text-gray-300">
              {count}
            </span>
          )}
        </HeadingTag>
        {subtitle && <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

export default SectionHeader;
